import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { LoaderComponent } from './loader/loader.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { AcademicNavigationComponent } from './academic-navigation/academic-navigation.component';
import { FloatingBarComponent } from './floating-bar/floating-bar.component';
import { ProgramShareComponent } from './program-share/program-share.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    LoaderComponent,
    ScrollTopComponent,
    AcademicNavigationComponent,
    FloatingBarComponent,
    ProgramShareComponent,
  ],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    LoaderComponent,
    ScrollTopComponent,
    AcademicNavigationComponent,
    FloatingBarComponent,
    ProgramShareComponent,
  ]
})
export class CoreModule { }
